import { render, staticRenderFns } from "./SalesReceipt.vue?vue&type=template&id=227402e8&"
import script from "./SalesReceipt.vue?vue&type=script&lang=js&"
export * from "./SalesReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports